const isTenantNodePool = pool => pool?.cloud === 'switch' && Boolean(pool.cluster_name)

export const tenantNodePools = pools => (Array.isArray(pools) ? pools.filter(isTenantNodePool) : [])

export const tenantNodePoolClusters = pools => {
    return [...new Set(tenantNodePools(pools).map(pool => pool.cluster_name))]
}

export const tenantNodePoolsForCluster = (pools, clusterName) => {
    if (!clusterName) return []
    return tenantNodePools(pools).filter(pool => pool.cluster_name === clusterName)
}

export const tenantNodePoolClusterIndex = (pools, nodePoolId) => {
    const tenantPools = tenantNodePools(pools)
    const selectedPool = tenantPools.find(pool => pool.node_pool === nodePoolId)
    if (!selectedPool) return -1
    return tenantNodePoolClusters(tenantPools).indexOf(selectedPool.cluster_name)
}
